/* UTOPIA LAB theme — cart drawer + interactions (Shopify AJAX API) */
(function () {
  // Self-contained money formatter (parses Shopify money_format string)
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const fmt = format || (window.UTOPIA && window.UTOPIA.moneyFormat) || '{{amount}} €';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(num, dec, thousands, decimalSep) {
      num = (num / 100).toFixed(dec);
      const parts = num.split('.');
      const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dec > 0 ? intPart + decimalSep + parts[1] : intPart;
    }
    switch ((fmt.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2, '.', ','); break;            // 1.234,56
      case 'amount_no_decimals': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = defaultTo(cents, 2, "'", '.'); break; // CHF 1'234.56
      default: value = defaultTo(cents, 2, '.', ',');
    }
    return fmt.replace(placeholderRegex, value);
  }
  const money = (cents) => formatMoney(cents, window.UTOPIA && window.UTOPIA.moneyFormat);

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(() => toastEl.classList.add('show'));
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('show'), 2600);
  }

  /* ---------- drawer ---------- */
  const drawer = $('#cartDrawer');
  function openDrawer() { drawer && drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer && drawer.classList.remove('open'); document.body.style.overflow = ''; }

  /* ---------- render cart ---------- */
  function freeShip() { return (window.UTOPIA.freeShipThreshold || 0) * 100; }

  function renderCart(cart) {
    const count = cart.item_count;
    $$('.cart-count').forEach((b) => {
      b.textContent = count;
      b.classList.toggle('show', count > 0);
    });

    const items = $('#cartItems');
    const foot = $('#cartFoot');
    if (!items) return;

    if (!count) {
      items.innerHTML = '<div class="drawer__empty"><p>Dein Warenkorb ist noch leer.</p><p class="serif" style="margin-top:.6rem">Such dir deinen Ton aus.</p></div>';
      if (foot) foot.style.display = 'none';
      const bar = $('#shipBar'); if (bar) bar.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';

    items.innerHTML = cart.items.map((it) => `
      <div class="citem" data-key="${it.key}">
        <img class="citem__img" src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x150$1') : ''}" alt="">
        <div>
          <a class="citem__name" href="${it.url}">${it.product_title}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="citem__meta">${it.variant_title}</div>` : ''}
          <div class="qty">
            <button data-act="dec">–</button>
            <input type="text" value="${it.quantity}" readonly aria-label="Menge">
            <button data-act="inc">+</button>
          </div>
          <a class="citem__rm" data-act="rm">Entfernen</a>
        </div>
        <div class="citem__price">${money(it.final_line_price)}</div>
      </div>`).join('');

    // shipping progress
    const bar = $('#shipBar');
    if (bar) {
      const thr = freeShip();
      if (thr > 0) {
        bar.style.display = '';
        const remain = Math.max(0, thr - cart.total_price);
        const pct = Math.min(100, (cart.total_price / thr) * 100);
        $('#shipText').innerHTML = remain > 0
          ? `Noch <b>${money(remain)}</b> bis zum kostenlosen Versand`
          : 'Du hast kostenlosen Versand freigeschaltet ✓';
        $('#shipFill').style.width = pct + '%';
      } else { bar.style.display = 'none'; }
    }

    const sub = $('#cartSubtotal');
    if (sub) sub.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.UTOPIA.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then((r) => r.json());
  }

  function addToCart(id, qty) {
    return fetch(window.UTOPIA.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then((r) => r.json());
  }

  function changeLine(key, qty) {
    return fetch(window.UTOPIA.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then((r) => r.json());
  }

  /* ---------- event wiring ---------- */
  document.addEventListener('click', (e) => {
    // open cart
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); fetchCart().then(renderCart).then(openDrawer); return; }

    // close cart
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }

    // add to cart (product form button)
    const add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      const id = add.getAttribute('data-variant-id');
      const qinput = document.querySelector('[data-qty-input]');
      const q = qinput ? parseInt(qinput.value, 10) || 1 : 1;
      add.disabled = true;
      addToCart(id, q)
        .then(() => fetchCart())
        .then((cart) => { renderCart(cart); toast(add.getAttribute('data-add-label') || 'Im Warenkorb'); openDrawer(); })
        .catch(() => toast('Etwas ist schiefgelaufen'))
        .finally(() => { add.disabled = false; });
      return;
    }

    // line item qty / remove
    const lineBtn = e.target.closest('.citem [data-act]');
    if (lineBtn) {
      const row = lineBtn.closest('.citem');
      const key = row.getAttribute('data-key');
      const act = lineBtn.getAttribute('data-act');
      const cur = parseInt(row.querySelector('input').value, 10) || 1;
      let next = cur;
      if (act === 'inc') next = cur + 1;
      else if (act === 'dec') next = cur - 1;
      else if (act === 'rm') next = 0;
      changeLine(key, next).then(renderCart);
      return;
    }

    // pdp qty stepper
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = document.querySelector('[data-qty-input]');
      if (input) {
        const v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, step.getAttribute('data-qty-step') === 'inc' ? v + 1 : v - 1);
      }
      return;
    }

    // accordion
    const accHead = e.target.closest('.acc__head');
    if (accHead) { accHead.closest('.acc__item').classList.toggle('open'); return; }

    // pdp thumb swap
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const main = document.querySelector('#pdpMain img');
      if (main) main.src = thumb.getAttribute('data-thumb');
      $$('[data-thumb]').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
      return;
    }
  });

  // scrim click closes
  document.addEventListener('click', (e) => {
    if (e.target.classList && e.target.classList.contains('drawer__scrim')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- scroll reveal ---------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.addEventListener('DOMContentLoaded', () => $$('.reveal').forEach((el) => io.observe(el)));
  } else {
    document.addEventListener('DOMContentLoaded', () => $$('.reveal').forEach((el) => el.classList.add('in')));
  }

  // init counts on load
  document.addEventListener('DOMContentLoaded', () => fetchCart().then(renderCart).catch(() => {}));

  // expose for inline use
  window.UTOPIA = window.UTOPIA || {};
  window.UTOPIA.addToCart = (id, q) => addToCart(id, q).then(fetchCart).then((c) => { renderCart(c); openDrawer(); });
})();
